<p class="draw-signature__instructions">Use your mouse or finger to draw your initials below.</p>

<app-signature-pad
  [existingSignature]="existingSignatureData"
  [showErrorMessages]="true"
  [mode]="'initials'"
  (cancelSignature)="cancelSignature()"
  (signatureSet)="saveSignature($event)"
></app-signature-pad>
